import CommunityPrograms from "../../components/home/community/CommunityPrograms";
import ContactHome from "../../components/home/contact-home/ContactHome";
import CoreValues from "../../components/home/core-values/CoreValues";
import Header from "../../components/home/header/Header";
import IsuzuAdvert from "../../components/home/isuzu-advert/IsuzuAdvert";
import MarketingIdentity from "../../components/home/marketing-identity/MarketingIdentity";
import MiniGallery from "../../components/home/mini-gallery/MiniGallery";
import OurStory from "../../components/home/our-story/OurStory";
import ProductsAndServices from "../../components/home/products-services/ProductsAndServices";
import Products from "../../components/home/products/Products";
import Stats from "../../components/home/stats/Stats";
import Markets from "../../components/markets/Markets";
// import { isMobile } from "react-device-detect";

function Home() {
  return (
    <>
      <section className="position-relative">
        <Header />
      </section>
      <section className="position-relative">
        <Stats />
      </section>
      <section className="position-relative">
        <Products />
      </section>
      <section className="position-relative">
        <Markets />
      </section>
      <section className="position-relative">
        <IsuzuAdvert />
      </section>
      <section className="position-relative">
        <ProductsAndServices />
      </section>
      <section className="position-relative d-none">
        <OurStory />
      </section>
      <section className="position-relative">
        <MarketingIdentity />
      </section>
      <section className="position-relative">
        <CoreValues />
      </section>
      <section className="position-relative">
        <CommunityPrograms />
      </section>
      <section className="position-relative">
        <MiniGallery />
      </section>
      <section className="position-relative">
        <ContactHome />
      </section>
    </>
  );
}

export default Home;
